import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=0db1fa97&scoped=true"
var script = {}
import style0 from "./Contacto.vue?vue&type=style&index=0&id=0db1fa97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1fa97",
  null
  
)

export default component.exports